import { Placement } from '@floating-ui/react-dom-interactions';
import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';

const upperBoxShadow = '1px -5px 14px 2px rgb(49 53 61 / 24%)';

type DropdownMenuProps = { placement?: Placement | ''; maxHeight: number | null };

type DropdownOptionProps = { active: boolean; disabled?: boolean };

type InputProps = { disabled?: boolean };

const dropdownMenuBase = css`
  background: ${theme.colors.white};
  box-shadow: ${theme.shadows.floating};
  margin: 0;
  outline: none;
  padding: 0;
  max-height: 250px;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.neutral20};
    border-radius: ${theme.borderRadius.small};
  }
`;

const dropdownMenuTopPlacement = css`
  box-shadow: ${upperBoxShadow};
`;

const dropdownMenuWithMaxHeight = css`
  max-height: none;
`;

const dropdownOptionBase = css`
  align-items: center;
  color: ${theme.colors.neutral90};
  cursor: default;
  display: flex;
  justify-content: space-between;
  min-height: 40px;
  outline: 0;
  padding: ${theme.spacing(1, 2)};
  width: 100%;
  .select-option-text {
    word-break: break-all;
  }
`;

const dropdownOptionActive = css`
  background: ${theme.colors.neutral5};
`;

const dropdownOptionDisabled = css`
  .select-option-text {
    color: ${theme.colors.status.disabled};
  }
  &:hover {
    background: none;
    cursor: not-allowed;
  }
`;

const inputBase = css`
  font-family: ${theme.font.family};
  font-size: ${theme.fontSize(16)};
  line-height: 1.375;
  padding-right: ${theme.spacing(4)};
  text-align: left;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  > input[type='text'] {
    margin-right: 0;
    padding-right: ${theme.spacing(3)};
    &::placeholder {
      color: ${theme.colors.black};
    }
  }
`;

const inputDisabled = css`
  color: ${theme.colors.status.disabled};
`;

export const inputStyle = ({ disabled }: InputProps) => cx(inputBase, disabled && inputDisabled);

export const DropdownFieldStyles = {
  dropdownMenu: ({ placement, maxHeight }: DropdownMenuProps) =>
    cx(dropdownMenuBase, placement === 'top' && dropdownMenuTopPlacement, !!maxHeight && dropdownMenuWithMaxHeight),
  dropdownMenuMaxHeightStyle: (maxHeight: number | null): React.CSSProperties | undefined =>
    maxHeight ? { maxHeight: `${maxHeight}px` } : undefined,
  dropdownOption: ({ active, disabled }: DropdownOptionProps) =>
    cx(dropdownOptionBase, active && dropdownOptionActive, disabled && dropdownOptionDisabled),
  dropdownInput: ({ disabled }: InputProps) => inputStyle({ disabled }),
};
